<template>
    <div class="tabs__content" v-if="active == name">
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        name: String,
        active: String
    }
}
</script>



// WEBPACK FOOTER //
// src/components/composer/Tabs/TabsContent.vue